/**
 * @generated SignedSource<<f1020c2e409329c1354d838fd1ff3c96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ecommerceTrackingProductData_item$data = {
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly contemporaryTrackingString: string;
  readonly displayPriceTracking: ReadonlyArray<{
    readonly amountType: string | null;
    readonly convertedAmountList: ReadonlyArray<{
      readonly amount: number | null;
      readonly currency: Currency | null;
    } | null> | null;
    readonly textType: string | null;
  } | null> | null;
  readonly isAuctionEnabled: boolean | null;
  readonly isNewListing: boolean | null;
  readonly personalizationType: string | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "ecommerceTrackingProductData_item";
};
export type ecommerceTrackingProductData_item$key = {
  readonly " $data"?: ecommerceTrackingProductData_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ecommerceTrackingProductData_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ecommerceTrackingProductData_item"
};

(node as any).hash = "a443a10d921acf2cbbd2c86dd65ca680";

export default node;
